<template>
  <div class="my-form">
    <div class="form-title">编辑预约单
      <Icon type="edit"></Icon>
    </div>
    <Form :model="formData" :label-width="100">
      <Row>
        <Col span="10">
      <div class="form-title">基础信息</div>
      <FormItem label="姓名">
        <Input v-model="formData.PrePressInfo.CustName" style="width:500px" placeholder="输入客户姓名"></Input>
      </FormItem>
      <FormItem label="电话 ">
        <Input v-model="formData.PrePressInfo.CustTel" style="width:500px" placeholder="输入客户电话"></Input>
      </FormItem>
      <FormItem label="短信电话 ">
        <Input v-model="formData.PrePressInfo.MsgTel" style="width:500px" placeholder="用于发送试压服务进度的短信接收号码"></Input>
      </FormItem>
      <FormItem label="管材类型">
        <RadioGroup v-model="formData.PrePressInfo.PipeTypeID" @on-change="PipeTypeChange">
          <Radio v-for="item in checkbox.PipeLineType" :label="item.ID">{{item.Name}}</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="是否家装单">
        <RadioGroup v-model="formData.PrePressInfo.IsCompany" @on-change="RadioChange">
          <Radio :label="0">否</Radio>
          <Radio :label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <div v-show="showCompany">
        <FormItem label="家装公司">
          <RadioGroup v-model="formData.PrePressInfo.CompanyID">
            <Radio v-for="item in checkbox.CompanyType" :label="item.ID">{{item.Name}}</Radio>
          </RadioGroup>
        </FormItem>
      </div> 
      <div v-show="showChargeAmount">
         <FormItem label="收费">
          <Input v-model="formData.PrePressInfo.ChargeAmount" style="width:500px" placeholder="收费请输入大于0的数字"></Input>
        </FormItem>
      </div>
      <FormItem label="行政区">
        <Cascader @on-change="AddressChange" :data="AddressData" v-model="selRegionCode" :load-data="loadregions" style="width:500px"></Cascader>
      </FormItem>
      <FormItem label="安装地址">
        <Input v-model="formData.PrePressInfo.CustAddr" style="width:500px" placeholder="具体门牌地址" @on-change="CheckRepeat"></Input>
      </FormItem>
      <FormItem label="预约试压日期">
        <DatePicker @on-change="DateChange" v-model="formData.PrePressInfo.PressureStartTime" format="yyyy/MM/dd" type="date" placeholder="选择日期" style="width: 200px"></DatePicker>
      </FormItem>
      <FormItem label="预约时间选择">
        <RadioGroup v-model="formData.PrePressInfo.HalfDay" @on-change="RadioChange">
          <Radio key="上午" label="上午">上午</Radio>
          <Radio key="下午" label="下午">下午</Radio>
          <Radio key="上午/下午" label="上午/下午">上午/下午</Radio>
        </RadioGroup>
      </FormItem>
      <div v-show="showTime">
        <FormItem label="具体时间">
          <TimePicker v-model="formData.PrePressInfo.DetailTime" format="HH:mm" placeholder="Select time" style="width: 120px" />
        </FormItem>
      </div>
      <FormItem label="报单号码">
        <Input v-model="formData.PrePressInfo.CallTel" style="width:500px" placeholder="输入报单号码"></Input>
      </FormItem>
      <FormItem label="备注">
        <Input v-model="formData.PrePressInfo.Remark" type="textarea" style="width:700px" :autosize="{minRows: 2,maxRows: 10}" placeholder="Enter something..."></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <div class="form-title">地图标点信息</div>
      <FormItem label="地址">
        <Input v-model="formData.PrePressMark.Title" style="width:500px" placeholder=""></Input>
        <div style="padding:10px">
          <div class="map-search-wrap">
            <Input
              v-model="mapSearchKeyword"
              placeholder="搜索地址"
              @on-change="onMapSearchInput"
              style="width:100%"
            />
            <ul v-show="mapTips.length" class="map-search-tips">
              <li
                v-for="(tip, idx) in mapTips"
                :key="idx"
                @click="selectMapTip(tip)"
              >
                <span class="tip-name">{{ tip.name }}</span>
                <span class="tip-addr">{{ tip.district || '' }}{{ tip.address || '' }}</span>
              </li>
            </ul>
          </div>
          <div id="detail-map" style="width:100%;height:400px;border:1px solid #dcdee2;border-radius:4px"></div>
          <div style="color:#888;font-size:12px;margin-top:4px">输入地址从下拉中选择，或直接点击地图选点（地址会自动填充）</div>
        </div>
      </FormItem>
      </Col>
      </Row>
      <FormItem>
        <Button @click="SubmitData" type="primary">保存</Button>
        <Button @click="BackList" type="default" style="margin-left: 8px">返回</Button>
      </FormItem>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </Form>
  </div>
</template>

<script>
import AMap from "@/utils/initMap";
export default {
  data() {
    return {
      spinShow: false,
      AddressData: [],
      showChargeAmount: true,
      showTime: false,
      showCompany: false,
      mapSearchKeyword: '',
      mapTips: [],
      mapSearchTimer: null,
      detailMap: null,
      AMapNS: null,
      geocoder: null,
      autoComplete: null,
      placeSearch: null,
      currentMarker: null,
      checkbox: {
        PipeLineType: [],
        BuyerIdentity: [],
        CompanyType: [],
      },
      selRegionCode: [],
      formData: {
        PrePressInfo: {
          AcceptTime: "",
          AgentDesc: "",
          AgentId: 0,
          CreateTime: "",
          CustAddr: "",
          CustAddrNum: "",
          CustName: "",
          CustSrvID: 0,
          CustTel: "",
          ID: 0,
          Identity: 0,
          LastEditTime: "",
          MsgTel: "",
          PipeTypeID: 0,
          PreSaleCode: "",
          PreSaleId: 0,
          PressureEndTime: "",
          PressureStartTime: "",
          RefuseReason: "",
          RefuseTime: "",
          RegionFullDesc: "",
          RegionLevel1: 430000,
          RegionLevel2: 430100,
          RegionLevel3: 430103,
          Status: 0,
          WorkerID: 0,
          _CreateBy: 0,
          _CreateTime: "",
          _IsDelete: 0,
          _UpdateBy: 0,
          _UpdateTime: "",
          ChargeAmount: 0,
          CallTel: "",
          Remark: "",
          IsCompany: 0,
          DetailTime: "",
          CompanyID:0,
          HalfDay: ""
        },
        PrePressMark:{
          PrePressId:"",
          Title:"",
          Lat:"",
          Lgt:"",
          RegionLevel1: 430000,
          RegionLevel2: 430100,
          RegionLevel3: 430103,
          _CreateBy: 0,
          _CreateTime: "",
          _IsDelete: 0,
          _UpdateBy: 0,
          _UpdateTime: ""
        }
      },
    };
  },
  methods: {
    AddressChange: function(value, selectedData) {
      this.formData.PrePressInfo.RegionFullDesc =
        selectedData[0].label + selectedData[1].label + selectedData[2].label;
      this.formData.PrePressInfo.CustAddrNum =
        selectedData[0].value +
        "," +
        selectedData[1].value +
        "," +
        selectedData[2].value;
      this.formData.PrePressInfo.RegionLevel1 = selectedData[0].value;
      this.formData.PrePressInfo.RegionLevel2 = selectedData[1].value;
      this.formData.PrePressInfo.RegionLevel3 = selectedData[2].value;
    },
    DateChange: function(value) {
      this.formData.PrePressInfo.PressureStartTime = value;
      this.formData.PrePressInfo.PressureEndTime = value;
    },
    SetLoc: function (lat, lng, title) {
      if (!this.formData.PrePressMark) {
        this.formData.PrePressMark = {
          PrePressId: "",
          Title: "",
          Lat: "",
          Lgt: "",
          RegionLevel1: 430000,
          RegionLevel2: 430100,
          RegionLevel3: 430103,
        };
      }
      this.formData.PrePressMark.Lat = lat;
      this.formData.PrePressMark.Lgt = lng;
      this.formData.PrePressMark.Title = title;
    },

    onMapSearchInput: function(val) {
      var that = this;
      if (this.mapSearchTimer) {
        clearTimeout(this.mapSearchTimer);
      }
      var keyword = (typeof val === 'string' ? val : (this.mapSearchKeyword || '')).trim();
      this.mapSearchKeyword = keyword;
      if (!keyword || !this.autoComplete) {
        this.mapTips = [];
        return;
      }
      this.mapSearchTimer = setTimeout(function() {
        that.autoComplete.search(keyword, function(status, result) {
          if (status === 'complete' && result.tips) {
            that.mapTips = result.tips.filter(function(tip) {
              return tip.name;
            });
          } else {
            that.mapTips = [];
          }
        });
      }, 300);
    },

    selectMapTip: function(tip) {
      var that = this;
      this.mapTips = [];
      this.mapSearchKeyword = tip.name;
      var title = (tip.district || '') + (tip.address || tip.name || '');

      var lng = null;
      var lat = null;
      if (tip.location) {
        if (typeof tip.location.getLng === 'function') {
          lng = tip.location.getLng();
          lat = tip.location.getLat();
        } else if (tip.location.lng && tip.location.lat) {
          lng = tip.location.lng;
          lat = tip.location.lat;
        }
      }

      if (lng != null && lat != null) {
        this.detailMap.setZoomAndCenter(16, [lng, lat], true);
        this.setLocationMarker(lat, lng, title || tip.name);
        return;
      }

      // 无坐标时用关键字再搜一次 POI
      if (!this.placeSearch) {
        this.$Message.info("未找到相关地址坐标");
        return;
      }
      this.placeSearch.search(tip.name, function(status, result) {
        if (status === 'complete' && result.poiList && result.poiList.pois.length > 0) {
          var poi = result.poiList.pois[0];
          that.detailMap.setZoomAndCenter(16, [poi.location.lng, poi.location.lat], true);
          that.setLocationMarker(
            poi.location.lat,
            poi.location.lng,
            poi.address || poi.name
          );
        } else {
          that.$Message.info("未找到相关地址坐标");
        }
      });
    },

    applyExistingMark: function() {
      if (!this.detailMap || !this.AMapNS) return;
      if (!this.formData.PrePressMark || !this.formData.PrePressMark.Lat || !this.formData.PrePressMark.Lgt) return;
      var lat = parseFloat(this.formData.PrePressMark.Lat);
      var lng = parseFloat(this.formData.PrePressMark.Lgt);
      if (isNaN(lat) || isNaN(lng)) return;
      this.setLocationMarker(lat, lng, this.formData.PrePressMark.Title || '');
      this.detailMap.setZoomAndCenter(16, [lng, lat], true);
    },

    // 设置位置标记
    setLocationMarker: function(lat, lng, title) {
      var AMap = this.AMapNS;
      if (!AMap || !this.detailMap) return;
      if (this.currentMarker) {
        this.detailMap.remove(this.currentMarker);
      }
      this.currentMarker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        title: title,
      });
      this.detailMap.add(this.currentMarker);
      this.SetLoc(lat, lng, title);
    },

    reverseGeocode: function(lng, lat) {
      var that = this;
      var doGeocode = function() {
        that.geocoder.getAddress([lng, lat], function(status, result) {
          var address = '';
          if (status === 'complete' && result && result.regeocode) {
            address =
              result.regeocode.formattedAddress ||
              result.regeocode.formatted_address ||
              '';
          }
          that.setLocationMarker(lat, lng, address);
        });
      };
      if (this.geocoder) {
        doGeocode();
        return;
      }
      if (!this.AMapNS) return;
      this.AMapNS.plugin('AMap.Geocoder', function() {
        that.geocoder = new that.AMapNS.Geocoder({ city: '长沙' });
        doGeocode();
      });
    },

    initDetailMapPlugins: function(AMap) {
      var that = this;
      AMap.plugin('AMap.Geocoder', function() {
        that.geocoder = new AMap.Geocoder({ city: '长沙' });
      });
      AMap.plugin('AMap.AutoComplete', function() {
        that.autoComplete = new AMap.AutoComplete({
          city: '长沙',
          citylimit: false,
        });
      });
      AMap.plugin('AMap.PlaceSearch', function() {
        that.placeSearch = new AMap.PlaceSearch({
          city: '长沙',
          pageSize: 10,
          pageIndex: 1,
        });
      });
    },

    SubmitData: function() {
      var that = this;
      var url = "PrePress/EditPrepress";
      try {
        that.formData.PrePressInfo.PressureEndTime = that.formData.PrePressInfo.PressureStartTime = that.formData.PrePressInfo.PressureStartTime.toLocaleDateString();
      } catch (error) {}

      console.log(that.formData.PrePressInfo.PressureStartTime);
      if(that.formData.PrePressInfo.HalfDay==null||that.formData.PrePressInfo.HalfDay==""){
        this.$Modal.warning({
          title: "提示",
          content: "请选择预约时间选择"
        });
        return false;
      }
      
      console.log(that.formData.PrePressInfo.HalfDay);
      this.$http.post(url, that.formData).then(res => {
        var modaltitle = "";
        if (res.data != "success") {
          modaltitle = res.data;
        } else {
          modaltitle = "提交成功！";
        }
        this.$Modal.info({
          title: "提示",
          content: modaltitle
        });
        this.$router.push({ name: "dealer_prepresslist" });
      });
    },
    loadregions: function(item, callback) {
      item.loading = true;
      this.GetRegions(item.level + 1, item.value).then(res => {
        item.children = PushAddress(res.data);
        item.loading = false;
        callback();
      });
    },
    GetRegions: function(level, regionID) {
      let that = this;
      return that.$http.get("Region/GetRegionByLevel", {
        params: {
          level: level,
          regionID: regionID
        }
      });
    },
    GetCheckbox: function() {
      let that = this;
      that.$http.get("CheckBox/GetCheckBoxs?type=5").then(res => {
        that.checkbox.BuyerIdentity = res.data;
      });
      that.$http.get("CheckBox/GetCheckBoxs?type=4").then(res => {
        that.checkbox.PipeLineType = res.data;
      });
      that.$http.get("CheckBox/GetCheckBoxs?type=33").then(res => {
        that.checkbox.CompanyType = res.data;
      });
    },
    GetPrePress: function(id) {
      var that = this;
      this.$http
        .get("PrePress/GetPrePressWithMark", { params: { id: id } })
        .then(res => {
          this.formData = res.data.Data;
          if(this.formData.PrePressInfo.IsCompany == 1){
            this.showTime = true; 
            this.showCompany = true; 
          }
          this.selRegionCode = [];
          this.selRegionCode.push(res.data.Data.PrePressInfo.RegionLevel1);
          this.selRegionCode.push(res.data.Data.PrePressInfo.RegionLevel2);
          this.selRegionCode.push(res.data.Data.PrePressInfo.RegionLevel3);

          // 如果有已标记的位置，在地图上显示
          that.applyExistingMark();
        })
        .catch(function() {})
        .then(function() {
          that.spinShow = false;
        });
    },
    PipeTypeChange: function(value) {
      if(value == 13){
          this.showChargeAmount = true; 
      }else{
          this.showChargeAmount = false; 
          this.formData.PrePressInfo.ChargeAmount=0;
      }
    },
    RadioChange: function(value) {
      if(value == 1){
        this.showTime = true;
        this.showCompany = true; 
      }else{
        this.showTime = false; 
        this.formData.PrePressInfo.DetailTime = "";
        this.showCompany = false; 
        this.formData.PrePressInfo.CompanyID = 0;
      }
    },
    BackList: function() {
      this.$http.SetConditions();
      this.$router.go(-1);
    },
    CheckRepeat() {
      this.$http
        .get("/Customer/CheckRepeat", {
          params: {
            custaddr: this.formData.PrePressInfo.CustAddr
          }
        }).then(res => {
          if(res.data!="success"){
            this.$Modal.info({ title: "提示", content: res.data });           
          }
      });
    }
  },
  watch: {},
  created: function() {
    var that = this;
    this.spinShow = true;
    this.GetCheckbox();
    this.GetRegions(1, "").then(res => {
      this.AddressData = PushAddress(res.data);
    });
  },
  mounted: function() {
    var that = this;
    this.GetPrePress(this.$route.query.id);

    AMap.init().then((AMap) => {
      that.AMapNS = AMap;
      that.detailMap = new AMap.Map("detail-map", {
        center: [112.977361, 28.19652],
        zoom: 12,
        viewMode: "2D",
      });

      // 点击立刻打点，不依赖插件回调（避免插件失败导致事件未绑定）
      that.detailMap.on("click", function(e) {
        var lng = e.lnglat.getLng ? e.lnglat.getLng() : e.lnglat.lng;
        var lat = e.lnglat.getLat ? e.lnglat.getLat() : e.lnglat.lat;
        that.mapTips = [];
        that.setLocationMarker(lat, lng, '');
        that.reverseGeocode(lng, lat);
      });

      that.initDetailMapPlugins(AMap);
      that.applyExistingMark();
    });
  }
};

//地址数组填充
function PushAddress(list) {
  var regionList = [];
  list.forEach(item => {
    if (item.Level != 3) {
      regionList.push({
        value: item.ID,
        label: item.RegionText,
        level: item.Level,
        parentID: item.ParentID,
        children: [],
        loading: false
      });
    } else {
      regionList.push({
        value: item.ID,
        label: item.RegionText,
        level: item.Level,
        parentID: item.ParentID
      });
    }
  });
  return regionList;
}
</script>

<style>
.map-search-wrap {
  position: relative;
  margin-bottom: 8px;
}
.map-search-tips {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 20;
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 240px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.map-search-tips li {
  padding: 8px 12px;
  cursor: pointer;
  line-height: 1.4;
}
.map-search-tips li:hover {
  background: #f3f3f3;
}
.map-search-tips .tip-name {
  display: block;
  color: #333;
}
.map-search-tips .tip-addr {
  display: block;
  color: #999;
  font-size: 12px;
}
</style>
